export default function useCleanQuoteOrInvoiceNumber(
    rawNumber: string | undefined,
): string | undefined {
    if (rawNumber === undefined) {
        return;
    }
    // Remove `q` from the beginning...
    return rawNumber.replace(/^q/, '');
}
